import { useContext } from 'react'

import { PerksContext } from '../providers/PerksProvider'

export const usePerksContext = () => {
  const perksContext = useContext(PerksContext)

  if (perksContext === undefined) {
    throw new Error('tiersContext must be used within a PerksProvider')
  }

  return perksContext
}
